export default function SPdf({ size = 20, className = "", ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="1.5 3 17 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M5.3125 18.3332C4.88281 18.3332 4.51562 18.1665 4.21094 17.8415C3.90625 17.5165 3.75 17.1248 3.75 16.6665V3.33317C3.75 2.87484 3.90625 2.48317 4.21094 2.15817C4.51562 1.83317 4.88281 1.6665 5.3125 1.6665H11.5625L16.25 6.6665V16.6665C16.25 17.1248 16.0938 17.5165 15.7891 17.8415C15.4844 18.1665 15.1172 18.3332 14.6875 18.3332H5.3125ZM10.7812 7.49984H14.6875L10.7812 3.33317V7.49984ZM5.99219 14.9998H6.77344V13.3332H7.55469C7.77344 13.3332 7.96094 13.2498 8.10938 13.0915C8.25781 12.9332 8.33594 12.7332 8.33594 12.4998V11.6665C8.33594 11.4332 8.25781 11.2332 8.10938 11.0748C7.96094 10.9165 7.77344 10.8332 7.55469 10.8332H5.99219V14.9998ZM6.77344 12.4998V11.6665H7.55469V12.4998H6.77344ZM9.11719 14.9998H10.6797C10.8984 14.9998 11.0859 14.9165 11.2344 14.7582C11.3828 14.5998 11.4609 14.3998 11.4609 14.1665V11.6665C11.4609 11.4332 11.3828 11.2332 11.2344 11.0748C11.0859 10.9165 10.8984 10.8332 10.6797 10.8332H9.11719V14.9998ZM9.89844 14.1665V11.6665H10.6797V14.1665H9.89844ZM12.2422 14.9998H13.0234V13.3332H13.8047V12.4998H13.0234V11.6665H13.8047V10.8332H12.2422V14.9998Z"
                fill="currentColor"
            />
        </svg>

    )
}